module.exports = __webpack_public_path__ + "res/Roboto-Condensed-webfont.ttf?90a2bfa631e724f5d75900da803a172f";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-Condensed-webfont.ttf
// module id = 39
// module chunks = 0